import Vue from "vue";
import i18n from "@/plugins/i18n";
import axios from "@/helpers/axios";

export default {
  namespaced: true,
  state: {
    loading: false,
    testResults: {},
    placementTest: {},
    myPlacementTests: {
      loading: false,
      data: []
    },
    placementTests: [],
    myPlacementTestResults: [],
    inviteListPlacementTestResults: [],
    studentPlacementTests: {}
  },
  mutations: {
    SET_PLACEMENT_TEST(state, data) {
      state.placementTest = data;
    },
    RESET_TEST_RESULTS(state) {
      state.testResults = {};
    },
    SET_PLACEMENT_TESTS(state, data) {
      state.placementTests = data;
    },
    SET_TEST_RESULTS(state, data) {
      state.testResults = data;
    },
    SET_LOADING_MY_PLACEMENT_TEST(state, data) {
      state.myPlacementTests.loading = data;
    },
    SET_MY_PLACEMENT_TEST(state, data) {
      state.myPlacementTests.data = data;
    },
    SET_MY_PLACEMENT_TEST_RESULTS(state, data) {
      state.myPlacementTestResults = data;
    },
    SET_INVITE_LIST_PLACEMENT_TEST_RESULTS(state, data) {
      state.inviteListPlacementTestResults = data;
    },
    SET_LOADING(state, data) {
      state.loading = data;
    },
    SET_STUDENT_PLACEMENT_TEST_RESULTS(state, data) {
      state.studentPlacementTests[data.studentId] = data.data;
    }
  },
  getters: {
    getStudentPlacementTestResults: state => studentId => {
      return state.studentPlacementTests[studentId]
        ? state.studentPlacementTests[studentId]
        : {};
    }
  },
  actions: {
    getPlacementTests({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        axios
          .get(`/stats/placement-test/`)
          .then(({ data }) => {
            commit("SET_PLACEMENT_TESTS", data);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          })
          .finally(() => {
            commit("SET_LOADING", false);
          });
      });
    },
    sendReminder({ dispatch }, { pk, emails }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/stats/placement-test/invite-list/${pk}/`, {
            emails
          })
          .then(({ data }) => {
            dispatch("getPlacementTests", data);
            Vue.notify({
              type: "success",
              group: "alert",
              title: i18n.t("success"),
              text: i18n.t("Reminder email Sent")
            });
            resolve(data);
          })
          .catch(error => {
            Vue.notify({
              type: "error",
              group: "alert",
              title: i18n.t("Uh oh?"),
              text: i18n.t("Couldn't send reminder email please try again.")
            });
            reject(error);
          });
      });
    },
    sendInvites({ dispatch }, { pk, emails }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/stats/placement-test/invite-list/${pk}/`, {
            emails
          })
          .then(({ data }) => {
            dispatch("getPlacementTests", data);
            Vue.notify({
              type: "success",
              group: "alert",
              title: i18n.t("success"),
              text: i18n.t("Invitations Sent")
            });
            resolve(data);
          })
          .catch(error => {
            Vue.notify({
              type: "error",
              group: "alert",
              title: i18n.t("Uh oh?"),
              text: i18n.t(
                "Couldn't send invites_Please check the emails and try again."
              )
            });
            reject(error);
          });
      });
    },
    sendUninvites({ dispatch }, { pk, emails }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/stats/placement-test/uninvite/${pk}/`, {
            data: { emails }
          })
          .then(({ data }) => {
            dispatch("getPlacementTests", data);
            Vue.notify({
              type: "success",
              group: "alert",
              title: i18n.t("success"),
              text: i18n.t("uninvited user")
            });
            resolve(data);
          })
          .catch(error => {
            Vue.notify({
              type: "error",
              group: "alert",
              title: i18n.t("Uh oh?"),
              text: i18n.t("Couldn't uninvite. Please try again.")
            });
            reject(error);
          });
      });
    },
    getPlacementTest({ commit }, id) {
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        axios
          .get(`/stats/placement-test/${id}/`)
          .then(({ data }) => {
            commit("SET_PLACEMENT_TEST", data);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          })
          .finally(() => {
            commit("SET_LOADING", false);
          });
      });
    },
    getPlacementTestResult({ commit }, id) {
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        axios
          .get(`stats/placement-test-result/${id}/`)
          .then(({ data }) => {
            commit("SET_TEST_RESULTS", data);
            resolve(data);
          })
          .catch(error => {
            commit("SET_TEST_RESULTS", {});
            reject(error);
          })
          .finally(() => {
            commit("SET_LOADING", false);
          });
      });
    },
    async gradePlacementTest({ commit }, postData) {
      try {
        const { data } = await axios.post(
          `/stats/placement-test/grade-test/`,
          postData
        );
        commit("SET_TEST_RESULTS", data);
      } catch {
        //
      }
    },
    async getMyPlacementTests({ commit }) {
      commit("SET_LOADING_MY_PLACEMENT_TEST", true);
      try {
        const { data } = await axios.get(`/stats/my-placement-tests/`);
        commit("SET_MY_PLACEMENT_TEST", data);
      } catch {
        //
      }
      commit("SET_LOADING_MY_PLACEMENT_TEST", false);
    },
    async getMyPlacementTestResults({ commit }) {
      try {
        const { data } = await axios.get(`/stats/my-placement-test-results/`);
        commit("SET_MY_PLACEMENT_TEST_RESULTS", data);
      } catch {
        //
      }
    },
    async getInviteListPlacementTestResults({ commit }) {
      try {
        const { data } = await axios.get(
          `/stats/invite-list-placement-test-results/`
        );
        commit("SET_INVITE_LIST_PLACEMENT_TEST_RESULTS", data);
      } catch {
        //
      }
    },
    async listStudentPlacementTestResults({ commit }, studentId) {
      try {
        const { data } = await axios.get(
          `stats/placement-test-results/student/` + studentId
        );
        commit("SET_STUDENT_PLACEMENT_TEST_RESULTS", {
          data: data,
          studentId: studentId
        });
      } catch {
        //
      }
    }
  }
};
